<template>
  <span v-if="variant === 'tab'">Needs follow-up<template v-if="counts"> ({{ counts.open }})</template></span>
  <!-- Same alert treatment as the wrestler Payments tab (wp-alert) -->
  <div v-else-if="counts && counts.open > 0" class="payments-callout" :class="counts.needs_you > 0 ? 'payments-callout--warning' : 'payments-callout--info'">
    <div>
      <div class="payments-callout__title">{{ title }}</div>
      <div v-if="body" class="payments-callout__body">{{ body }}</div>
    </div>
    <a href="#follow-ups" class="btn btn-default btn-compact" @click.prevent="openTab">Review follow-ups</a>
  </div>
</template>
<script>
// The Needs follow-up tab's label count, or the callout above the payments
// dashboard's charts, from the open follow-up counts (the list itself only
// loads once the tab is opened).
export default {
  name: 'payment-follow-ups-count',
  props: {
    variant: { type: String, default: 'tab' },
  },
  data() {
    return {
      counts: null,
    };
  },
  computed: {
    // Coach action first; what the system is retrying is the secondary line
    title() {
      const { needs_you: needsYou, retrying } = this.counts;
      if (needsYou > 0) {
        return `${needsYou} ${needsYou === 1 ? 'payment needs' : 'payments need'} follow-up`;
      }
      return `${retrying} card ${retrying === 1 ? 'payment is' : 'payments are'} being retried`;
    },
    body() {
      const { needs_you: needsYou, retrying } = this.counts;
      if (needsYou > 0 && retrying > 0) {
        return `${retrying} more card ${retrying === 1 ? 'payment is' : 'payments are'} being retried automatically.`;
      }
      return needsYou > 0 ? 'Cash or check to collect, or a subscription nothing is retrying.' : 'The family has been emailed a link to update their card.';
    },
  },
  created() {
    axios.get(this.$apiService.paymentFollowUpsSummaryUrl())
      .then((response) => {
        this.counts = response.data;
      })
      .catch(() => {
        // Counts are a nicety; the tab still works without them
      });
  },
  methods: {
    openTab() {
      $('a[href="#follow-ups"]').tab('show');
      document.getElementById('dashboard-tabs').scrollIntoView({ behavior: 'smooth' });
    },
  },
};
</script>
